// cmps/TextEditor/utils/editorDraft.util.js
import { utilService } from '../../../services/util.service'

const STORAGE_KEY = 'lexical-draft'
let lastSaved = '' // JSON string האחרונה

/* ---------- שמירה ---------- */
export function saveEditorDraft(editorState) {
  // editorState מגיע כ-instance של EditorState אך אין צורך לבדוק instanceof
  if (!editorState || typeof editorState.toJSON !== 'function') return

  const jsonStr = JSON.stringify(editorState.toJSON())
  if (jsonStr === lastSaved) return // לא השתנה → לא כותבים

  utilService.saveToLocalStorage(STORAGE_KEY, jsonStr)
  lastSaved = jsonStr
}

/* ---------- טעינה ---------- */
export function loadEditorDraft(editor) {
  const savedStr = utilService.getFromLocalStorage(STORAGE_KEY)
  if (!savedStr) return
  try {
    const parsed = editor.parseEditorState(savedStr) // JSON → EditorState
    editor.setEditorState(parsed) // החלפת ה-state
  } catch {
    clearEditorDraft() // במקרה ש-JSON פגום
  }
}

/* ---------- מחיקה ידנית ---------- */
export function clearEditorDraft() {
  utilService.removeFromLocalStorage(STORAGE_KEY)
  lastSaved = ''
}
